import { Component, OnInit } from '@angular/core';
import { DocService } from "../services/doc.service";
import { ActivatedRoute } from '@angular/router';


@Component({
	selector: 'license-component',
	templateUrl: './license.component.html',
	styleUrls: ['./license.component.scss'],
	providers: [DocService]
})

export class LicenseComponent {
	constructor(private _docService: DocService, private _activatedRoute: ActivatedRoute) { 
	}

	async ngOnInit() {
	}	

	public get license(): string {
		return '```\n' + this._docService.License.replace(/#/g, ' ') + '\n```';
	}
}
